import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import { Customer } from '../customer/customer.model';

@Endpoint('onboardings', 'Onboarding')
export class Onboarding extends ApiResource<Onboarding> {
  aspirant!: Customer;
}
